
import { mapState } from "vuex";

export default {
  props: {
    styles: { type: Object, default: () => {} },
    checkoutButtonText: { type: String, default: "" },
  },
  computed: mapState("bag", ["cart"]),
};
